import React from 'react';
import PropTypes from 'prop-types';

import { NO_REVIEW_AVAILABLE } from 'commons/constants';
import MixedGridCard from './MixedGridCard';
import MixedGridCardPlaceholder from './MixedGridCardPlaceholder';

const MixedGridItems = ({
  from = '',
  loadingMore,
  data,
  hits,
  hoveredValue,
  layout,
  onHoverHandler,
  toggleModalView,
}) => (
  <>
    {!!data.length &&
      data.map((card, index) => (
        <div
          key={
            card.card_type === 'customer_photo'
              ? `photo-id-${card.photo_id}`
              : `${card.id}`
          }
          className="mixed-grid-item max-[767px]:[&>*]:max-w-[100vw]"
        >
          <MixedGridCard
            {...card}
            index={index}
            hits={hits}
            hoveredValue={hoveredValue}
            layout={layout}
            onHoverHandler={onHoverHandler}
            toggleModalView={toggleModalView}
          />
        </div>
      ))}
    {!data.length && from === 'review' && (
      <div className="text-center font-normal">{NO_REVIEW_AVAILABLE}</div>
    )}
    {loadingMore && <MixedGridCardPlaceholder />}
  </>
);

MixedGridItems.propTypes = {
  data: PropTypes.array,
  from: PropTypes.string,
  gridWithOneCol: PropTypes.bool,
  gridWithReviews: PropTypes.bool,
  hits: PropTypes.number,
  hoveredValue: PropTypes.object,
  isMixedGridTab: PropTypes.bool,
  keyId: PropTypes.string,
  layout: PropTypes.string,
  loading: PropTypes.bool,
  loadMore: PropTypes.func,
  loadingMore: PropTypes.bool,
  maxCardsCount: PropTypes.number,
  onHoverHandler: PropTypes.func,
  toggleModalView: PropTypes.func,
};

export default MixedGridItems;
